define('controllers/mysetting/namechange/name-change-mod-userinfocorp.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('NameChangeModUserInfoCorp', ['$q', '$scope', '$state', '$location', '$rootScope', '$controller', 'auiUpload',
        'auiDialog', 'regionService', 'modUserInfoService', 'formValidateService', 'UserInfoPreload', 'modBussService',
        'langService', 'commonUtils', 'UserInfo',
        function ($q, $scope, $state, $location, $rootScope, $controller, auiUpload,
                  auiDialog, regionService, modUserInfoService, formValidateService, UserInfoPreload, modBussService, langService, commonUtils, UserInfo) {
            $controller('ModUserInfoCorp', {$scope: $scope});//导入
            var Model = $scope.Model;
            Model.isHasBankInfoReview = false;

            var userInfo = Model.userInfo = {
                'contactorImg1': '',
                'contactorImg2': '',
                'contactorImg3': '',
                'contactorImg11': '',
                'contactorImg10': '',
                'corpNameChange': '',
                'corpLicense': '',
                'tax': '',
                'corpCode': '',
                'corpEntityPicFile': '',
                'corpEntityPicFile1': ''
            };
            Model.hwCloudIdShow = false
            Model.isTipShow = false;
            Model.firstmessTip = '';
            Model.secondmessTip = '';
            Model.submbIsGray = true;
            Model.doSubmit = function () {
            };
            Model.inputIsDisable = true;
            Model.isShowChaicon = true;
            Model.isAudting = false;
            Model.isRadioDisable = false;
            Model.isShowphoneValid = false;
            Model.isRepeatCorpName = false;
            Model.verifiedEmailSuccess = false;
            Model.verifiedPhoneSuccess = false;
            Model.userInfo.country = {
                'key': '',
                'value': ''
            };
            Model.channelsList = systemParaConf.authentication.channels;
            Model.channelOtherCheck = false;
            Model.channelsChecked = [];
            Model.remark4userinfo = '';
            Model.verifyBankState = UserInfoPreload.verifyBankState;
            Model.isShowEmailValid = false;
            Model.notAltModDevName = false;
            Model.greenSubmit = greenSubmit;
            Model.graySubmit = graySubmit;

            //是否简化实名标识
            Model.isShowSimplifyApproval = false;

            Model.isShowNormalApproval = true;


            //定义各输入框对应的素数（控制提交按钮是否展示）
            var primes = modUserInfoService.returnPrimes();

            var oldUserInfo = {};
            var userInfoToString = '';

            Model.isEmailNeedCode = false;

            // 显示语种集合
            Model.notifyMsgLangList = sysParamCfg.displaylangCountries;

            // 是否维护通知消息语种
            Model.showMsgLang = sysParamCfg.displayMsgLangFlag;
            $scope.photoUrl = sysParamCfg.photoUrl;


            //SRM PRM错误信息展示
            Model.isShowPrmSrmTip = false;
            Model.PrmSrmMsgTip = "";


            init();

            function init() {
                modBussService.getMerchantInfo(function (bankInfos) {
                    //有境内银行帐号,且境内银行帐号和跨境银行帐号 在审核中的情况，则不展示更名按钮
                    if (bankInfos.bankInfoCN) {
                        if (bankInfos.bankInfoCN.verifyBankState === 1 || bankInfos.bankInfoCN.updateBankState === 1 ||
                            (bankInfos.bankInfoEN && (bankInfos.bankInfoEN.verifyBankState === 1 || bankInfos.bankInfoEN.updateBankState === 1))) {
                            Model.isHasBankInfoReview = true;
                        }
                    }

                    Model.userInfo.corpName = UserInfoPreload.realName;
                    if (UserInfoPreload.alChgRealName != 1 || UserInfoPreload.isChangeRealName == 1 || UserInfoPreload.updateRealState == 1 || Model.isHasBankInfoReview) {
                        delete $rootScope.changeNameParams;
                        $state.go('mysetting.modUserInfoCorp', {}, {reload: true});
                    } else {
                        Model.downChangeNameTemplate = systemParaConf.ChangeEnterpriseNameTemp.ChangeEnterpriseNameTempUrl;
                        Model.countrys = [{'key': '中国', 'value': '中国'}];

                        // 获取省份，现在统一到idata中，通过opendeveloper接口封装
                        regionService.setProvince(function (data) {
                            Model.provinces = data;
                            //获取cp信息展示
                            UserInfo.userAcctInfoList().then(function (userInfo) {
                                setUserInfo(userInfo);
                            });
                            Model.userInfo.country = Model.countrys[0];
                        });
                    }
                });
            }

            function getExtAttr(name) {
                var defer = $q.defer();
                modUserInfoService.getExtAttr(name).then(function (flag) {
                    defer.resolve(flag);
                });
                return defer.promise;
            }


            function validateData() {
                if (Model.isEmailNeedCode && !Model.verifiedEmailSuccess) {
                    angular.element("[name='verifyEmailCode']").focus();
                    return false;
                }
                if (Model.isPhoneNeedCode && !Model.verifiedPhoneSuccess) {
                    angular.element("[name='verifyCode']").focus();
                    return false;
                }
                return true;
            }

            //选择或或知渠道
            Model.selectChannel = function (value) {
                modUserInfoService.selectChannelType(value, Model, primes, undefined, undefined, oldUserInfo);
            }

            Model.uploadContactorImg1 = function (files, options) {
                Model.upload2openUP(files, options, primes.contactorImg1Prime, 'contactorImg1', 'contactorImg1WH');
            };

            Model.uploadContactorImg2 = function (files, options) {
                Model.upload2openUP(files, options, primes.contactorImg2Prime, 'contactorImg2', 'contactorImg2WH');
            };

            Model.uploadContactorImg3 = function (files, options) {
                Model.upload2openUP(files, options, primes.contactorImg3Prime, 'contactorImg3', 'contactorImg3WH');
            };

            Model.uploadCorpNameChange = function (files, options) {
                Model.upload2openUP(files, options, primes.corpNameChangePrime, 'corpNameChange', 'corpNameChangeWH');
            };

            Model.uploadContactorImg11 = function (files, options) {
                Model.upload2openUP(files, options, primes.contactorImg11Prime, 'contactorImg11', 'contactorImg11WH');
            };

            Model.uploadContactorImg10 = function (files, options) {
                Model.upload2openUP(files, options, primes.contactorImg10Prime, 'contactorImg10', 'contactorImg10WH');
            };

            Model.uploadCorpLicense = function (files, options) {
                Model.upload2openUP(files, options, primes.corpLicensePrime, 'corpLicense', 'corpLicenseWH');
            };

            Model.uploadTax = function (files, options) {
                Model.upload2openUP(files, options, primes.taxPrime, 'tax', 'taxWH');
            };

            Model.uploadCorpCode = function (files, options) {
                Model.upload2openUP(files, options, primes.corpCodePrime, 'corpCode', 'corpCodeWH');
            };

            Model.uploadCorpEntityPicFile = function (files, options) {
                Model.upload2openUP(files, options, primes.corpEntityPicFilePrime, 'corpEntityPicFile', 'corpEntityPicFileWH');
            };

            Model.uploadCorpEntityPicFile1 = function (files, options) {
                Model.upload2openUP(files, options, primes.corpEntityPicFile1Prime, 'corpEntityPicFile1', 'corpEntityPicFile1WH');
            };

            Model.uploadAppealAttach = function (files, options) {
                Model.upload2openUP(files, options, primes.appealAttach, 'appealAttach', 'appealAttach');
            };


            Model.cancel = function () {
                delete $rootScope.changeNameParams;
                $rootScope.modFlag = false;
                delete $rootScope.isInNameChange;
                $state.go('mysetting.modUserInfoCorp', {}, {reload: true});
            };


            Model.corpNameKeyup = function (valid) {
                if (oldUserInfo.corpName != AUI.HTMLUtil.transEnComma(Model.userInfo.corpName)) {
                    if (valid) {
                        modUserInfoService.checkUser({
                            userType: 2,
                            corpName: AUI.HTMLUtil.transEnComma(Model.userInfo.corpName)
                        }).then(function (res) {
                            if (res && res.isRepeat == 2) {
                                Model.isRepeatCorpName = false;
                            } else if (res && res.isRepeat == 1) {
                                Model.isRepeatCorpName = false;
                            }
                        });
                        greenSubmit();
                    } else {
                        Model.isRepeatCorpName = false;
                    }
                }
                else {
                    Model.submbIsGray = true;
                    Model.isRepeatCorpName = false;
                }
            };


            Model.contactEmailKeyup = function () {
                Model.isEmailNeedCode = (!UserInfo.checkIsSameWithUPEmail(Model.userInfo.contactEmail, Model.userInfo.accountEmail)
                && Model.userInfo.contactEmail != oldUserInfo.contactEmail)
            };

            Model.contactPhoneKeyup = function () {
                Model.isPhoneNeedCode = (!UserInfo.checkIsSameWithUPPhone(Model.userInfo.contactPhone, Model.userInfo.accountPhone)
                && Model.userInfo.contactPhone != oldUserInfo.contactPhone)
            };


            Model.acceptEDMKeyup = function (acceptEDM) {
                Model.userInfo.acceptEDM = !acceptEDM;
            };

            // 提交按钮灰化
            function graySubmit() {
                if (oldUserInfo.corpName == AUI.HTMLUtil.transEnComma(Model.userInfo.corpName)) {
                    Model.submbIsGray = true;
                    Model.doSubmit = function () {
                    };
                } else {
                    Model.submbIsGray = false;
                }
                if (!$rootScope.changeNameParams) {
                    $rootScope.modFlag = false;
                    delete $rootScope.isInNameChange;
                }
            }

            // 提交按钮亮化
            function greenSubmit() {
                if (oldUserInfo.corpName != AUI.HTMLUtil.transEnComma(Model.userInfo.corpName)) {
                    Model.submbIsGray = false;
                    Model.doSubmit = doSummit;
                } else {
                    Model.submbIsGray = true;
                }
                $rootScope.modFlag = true;
                $rootScope.isInNameChange = true;
            }

            //修改提交
            function doSummit(isValid) {
                var defer = $q.defer();
                if (!Model.submbIsGray) {
                    if (!isValid) {
                        defer.reject();
                        validateData();
                        formValidateService.validateForm($scope.corpUserForm);
                    } else {
                        if (!validateData()) {
                            defer.reject();
                            return;
                        }
                        //渠道不为为空
                        if (Model.channelsChecked.length != 0) {
                            Model.channelOtherCheck = false;
                        } else {
                            Model.channelOtherCheck = true;
                            defer.reject();
                            return;
                        }
                        var params = getUpdateParam();
                        if (oldUserInfo.corpName == AUI.HTMLUtil.transEnComma(Model.userInfo.corpName)) {
                            defer.reject();
                            auiDialog.warn('请修改企业全称。');
                        } else {
                            if (UserInfoPreload.verifyBankState == 2) {
                                if ($rootScope.changeNameParams) {
                                    defer.resolve();
                                    if (params.developerInfo) {
                                        $rootScope.changeNameParams.developerInfo = params.developerInfo;
                                    }
                                    if (params.corpDeveloper) {
                                        $rootScope.changeNameParams.corpDeveloper = params.corpDeveloper;
                                    }
                                } else {
                                    $rootScope.changeNameParams = params;
                                }
                                $rootScope.changeNameParams.isRepeatCorpName = Model.isRepeatCorpName;
                                if (UserInfoPreload.verifyBankState == 2) {
                                    $state.go("nameChangeCorp.modBussnessInfo");
                                } else {
                                    $state.go("nameChangeCorp.modInvoice");
                                }
                            } else {
                                modUserInfoService.changeNameFun(angular.copy(params)).then(function (data) {
                                    if (data) {
                                        $rootScope.modFlag = false;
                                        delete $rootScope.isInNameChange;
                                        auiDialog.success("提交更名成功", function () {
                                            delete $rootScope.changeNameParams;
                                            $scope.$emit("stateChangedEvent", true);
                                            $state.go('mysetting.modUserInfoCorp', {}, {reload: true});
                                        });
                                        defer.resolve();
                                    } else {
                                        defer.reject();
                                    }
                                }).catch(function () {
                                    defer.reject();
                                });
                            }
                        }
                    }
                } else {
                    defer.reject();
                }
                return defer.promise;
            }

            // 组织更新接口调用的请求参数
            function getUpdateParam() {
                /*
                 * 组装developerInfo数据
                 */
                var devObj = {};
                devObj.country = 'CN';
                if (oldUserInfo.contactName != Model.userInfo.contactName) {
                    devObj.contactName = Model.userInfo.contactName;
                }
                if (oldUserInfo.contactEmail != Model.userInfo.contactEmail) {
                    devObj.contactEmail = Model.userInfo.contactEmail;
                }
                if (oldUserInfo.contactPhone != Model.userInfo.contactPhone) {
                    devObj.contactPhone = Model.userInfo.contactPhone;
                }
                if (oldUserInfo.qq != Model.userInfo.qq) {
                    devObj.contactQQ = Model.userInfo.qq;
                }
                if (oldUserInfo.realNameEn != $.trim(Model.userInfo.realNameEn)) {
                    // 隐藏数据提交
                    devObj.realNameEn = $.trim(Model.userInfo.realNameEn);
                }

                if (Model.isSupportDevName) {
                    if (oldUserInfo.devName4Inner != $.trim(Model.userInfo.devName4Inner)) {
                        // 隐藏数据提交
                        devObj.devName4Inner = $.trim(Model.userInfo.devName4Inner);
                    }
                }
                // 需要验证的手机号码提交验证码
                if (Model.isEmailNeedCode) {
                    devObj.emailAuthCode = Model.userInfo.verEmailCode;
                }

                // 需要验证的手机号码提交验证码
                if (Model.isPhoneNeedCode) {
                    devObj.smsAuthCode = $.trim(Model.userInfo.verCode);
                }


                if (Model.needAppealAttach && Model.userInfo.appealAttach) {
                    devObj.appealAttach = Model.userInfo.appealAttach;
                }

                /*
                 * 组装corpDeveloper数据
                 */
                var corpObj = {};


                if (oldUserInfo.corpName != $.trim(AUI.HTMLUtil.transEnComma(Model.userInfo.corpName))) {
                    devObj.realName = AUI.HTMLUtil.transEnComma(Model.userInfo.corpName);
                    corpObj.corpName = AUI.HTMLUtil.transEnComma(Model.userInfo.corpName);
                }

                if (oldUserInfo.corpAddress != $.trim(Model.userInfo.corpAddress)) {
                    corpObj.corpAddress = $.trim(Model.userInfo.corpAddress);
                }

                if (oldUserInfo.corpBsLicID != $.trim(Model.userInfo.corpBsLicID)) {
                    corpObj.corpBsLicID = $.trim(Model.userInfo.corpBsLicID);
                }
                // 最新省份和城市使用key的形式保存
                if (oldUserInfo.provinceName != Model.userInfo.province.key) {
                    corpObj.provinceName = Model.userInfo.province.key;
                    devObj.province = Model.userInfo.province.key;
                }
                if (oldUserInfo.cityName != Model.userInfo.city.key) {
                    corpObj.cityName = Model.userInfo.city.key;
                    devObj.city = Model.userInfo.city.key;
                }

                modUserInfoService.setLearnchannels(oldUserInfo, Model, devObj);
                if (oldUserInfo.remark4userinfo != Model.userInfo.remark4userinfo) {
                    devObj.remark4userinfo = Model.userInfo.remark4userinfo;
                }

                // 通知消息语种
                if (oldUserInfo.msgLang != Model.userInfo.msgLang) {
                    // 通知消息语种
                    devObj.msgLang = Model.userInfo.msgLang;
                }


                //图片


                //简化实名用户申请资料变更有三种情况
                //1、名称未变化  contactorImg1 不空 把1，2，3,4,5,10置空
                //2、名称未变化  contactorImg1 空
                //3、名称变化   contactorImg1 不空
                //4、名称变化   contactorImg1 空
                if (Model.userInfo.corpLicense && oldUserInfo.corpLicense != Model.userInfo.corpLicense) {
                    corpObj.attachment1 = Model.userInfo.corpLicense;
                }
                if (!Model.userInfo.corpLicense) {
                    corpObj.attachment1 = '';
                }
                if (Model.userInfo.tax && oldUserInfo.tax != Model.userInfo.tax) {
                    corpObj.attachment2 = Model.userInfo.tax;
                }
                if (!Model.userInfo.tax) {
                    corpObj.attachment2 = '';
                }
                if (Model.userInfo.corpCode && oldUserInfo.corpCode != Model.userInfo.corpCode) {
                    corpObj.attachment3 = Model.userInfo.corpCode;
                }
                if (!Model.userInfo.corpCode) {
                    corpObj.attachment3 = '';
                }
                if (Model.userInfo.contactorImg10 && oldUserInfo.contactorImg10 != Model.userInfo.contactorImg10) {
                    corpObj.attachment10 = Model.userInfo.contactorImg10;
                }
                if (Model.userInfo.corpEntityPicFile && oldUserInfo.corpEntityPicFile != Model.userInfo.corpEntityPicFile) {
                    corpObj.attachment4 = Model.userInfo.corpEntityPicFile;
                }
                if (Model.userInfo.corpEntityPicFile1 && oldUserInfo.corpEntityPicFile1 != Model.userInfo.corpEntityPicFile1) {
                    corpObj.attachment5 = Model.userInfo.corpEntityPicFile1;
                }

                corpObj.isThreeInOne = 1;
                if (Model.userInfo.legalMan) {//法人姓名
                    corpObj.legalMan = Model.userInfo.legalMan;
                }
                if (Model.userInfo.legalManCtfCode) {//法人身份证号
                    corpObj.legalManCtfCode = Model.userInfo.legalManCtfCode;
                }

                corpObj.attachment6 = Model.userInfo.corpNameChange;
                corpObj.attachment11 = Model.userInfo.contactorImg11;
                // 组装最终的请求参数对象
                var params = {};
                if (!AUI.BaseJSUtil.isEmptyArray(devObj)) {
                    params.developerInfo = devObj;
                }
                if (!AUI.BaseJSUtil.isEmptyArray(corpObj)) {
                    params.corpDeveloper = corpObj;
                }

                return params;
            }

            function setUserInfo(userInfo) {
                var userInfoCopy = angular.copy(userInfo);
                if (userInfoCopy.devName4Inner == undefined) userInfoCopy.devName4Inner = "";
                modUserInfoService.saveOldUserInfo(oldUserInfo, userInfoCopy);
                userInfoToString = angular.toJson(angular.copy(userInfoCopy));
                if ($rootScope.changeNameParams && $rootScope.changeNameParams.developerInfo && $rootScope.changeNameParams.developerInfo.smsAuthCode) {
                    userInfoCopy.contactPhone = $rootScope.changeNameParams.developerInfo.contactPhone;
                }
                if ($rootScope.changeNameParams && $rootScope.changeNameParams.developerInfo && $rootScope.changeNameParams.developerInfo.emailAuthCode) {
                    userInfoCopy.contactEmail = $rootScope.changeNameParams.developerInfo.contactEmail;
                }
                Model.userInfo = angular.copy(userInfoCopy);
                Model.oldDevName4Inner = angular.copy(Model.userInfo.devName4Inner);
                Model.oldLegalMan = angular.copy(Model.userInfo.legalMan);//处理展示逻辑
                Model.oldLegalManCtfCode = angular.copy(Model.userInfo.legalManCtfCode);//处理展示逻辑
                if(Model.userInfo.verifyType == 3 && Model.userInfo.verifyRealType == 4) {
                    Model.hwCloudIdShow = true
                }
                //企业用户简化认证
                if (UserInfoPreload.userType == 2 && UserInfoPreload.verifyRealType == 1) {
                    Model.userInfo.userTypeDesc = mainCons.modUserinfoConstant.corUserType.simpleCertification;
                    Model.isShowSimplifyApproval = false;  //隐藏三张，显示五张
                    Model.isShowNormalApproval = true;
                }
                //企业用户正常实名认证,或简化转正常用户
                else if (UserInfoPreload.userType == 2 && (UserInfoPreload.verifyRealType == 0 || UserInfoPreload.verifyRealType == 4 || (UserInfoPreload.verifyRealType == 2 && !UserInfoPreload.contactorImg1))) {
                    Model.isShowSimplifyApproval = false;
                    Model.isShowNormalApproval = true;

                    if (UserInfoPreload.isThreeInOne == 0) {
                        Model.userInfo.corpLicense = '';
                        Model.userInfo.tax = '';
                        Model.userInfo.corpCode = '';
                    }
                }
                //企业用户简化
                else if (UserInfoPreload.userType == 2 && UserInfoPreload.verifyRealType == 2) {
                    Model.isShowSimplifyApproval = true;
                    Model.isShowNormalApproval = false;
                }
                //个人转企业用户
                else {
                    Model.isShowSimplifyApproval = true;
                    Model.isShowNormalApproval = false;
                }


                // 获取省份和城市，现在统一通过idata来获取
                Model.userInfo.province = {
                    'key': Model.userInfo.provinceName,
                    'value': regionService.getProvinceFromList(Model.userInfo.provinceName, Model.provinces)
                };
                if (!($rootScope.changeNameParams && $rootScope.changeNameParams.corpDeveloper && $rootScope.changeNameParams.corpDeveloper.cityName)) {
                    regionService.setCity(Model.userInfo.provinceName, function (data) {
                        Model.cities = data;
                        Model.userInfo.city = {
                            'key': Model.userInfo.cityName,
                            'value': regionService.getCityFromList(Model.userInfo.cityName, Model.cities)
                        };
                    });
                }
                //获取获知渠道
                if (Model.userInfo.learnchannels) {
                    Model.channelsChecked = Model.userInfo.learnchannels.split(';');
                    for (var ch = 0; ch < Model.channelsChecked.length; ch++) {
                        Model.channelsChecked[ch] = parseInt(Model.channelsChecked[ch]);
                    }
                }


                Model.isShowChaicon = true;
                Model.userInfo.contactorImg11 = '';
                Model.userInfo.corpNameChange = '';


                if ($rootScope.changeNameParams) {
                    Model.submbIsGray = false;
                    $rootScope.modFlag = true;
                    $rootScope.isInNameChange = true;
                    Model.doSubmit = doSummit;
                    var params = angular.copy($rootScope.changeNameParams);
                    var devObj = {};
                    var corpObj = {};
                    if (params.isRepeatCorpName) {
                        Model.isRepeatCorpName = params.isRepeatCorpName;
                    }
                    if (!AUI.BaseJSUtil.isEmptyArray(params.developerInfo)) {
                        devObj = params.developerInfo;
                    }
                    if (!AUI.BaseJSUtil.isEmptyArray(params.corpDeveloper)) {
                        corpObj = params.corpDeveloper;
                    }
                    if (devObj.contactName) {
                        Model.userInfo.contactName = devObj.contactName;
                    }
                    if (devObj.contactEmail) {
                        Model.userInfo.contactEmail = devObj.contactEmail;
                    }
                    if (devObj.acceptEDM) {
                        Model.userInfo.acceptEDM = devObj.acceptEDM == 1 ? true : false;
                    }
                    if (devObj.contactQQ) {
                        Model.userInfo.qq = devObj.contactQQ;
                    }
                    if (devObj.realNameEn) {
                        Model.userInfo.realNameEn = devObj.realNameEn;
                    }
                    if (devObj.smsAuthCode) {
                        Model.verifiedPhoneSuccess = true;
                        Model.isPhoneNeedCode = true;
                        Model.userInfo.verCode = devObj.smsAuthCode;
                    }
                    if (devObj.emailAuthCode) {
                        Model.isEmailNeedCode = true;
                        Model.verifiedEmailSuccess = true;
                        Model.userInfo.verEmailCode = devObj.emailAuthCode;
                    }
                    if (corpObj.corpName) {
                        Model.userInfo.corpName = corpObj.corpName;
                    }
                    if (corpObj.corpAddress) {
                        Model.userInfo.corpAddress = corpObj.corpAddress;
                    }

                    if (corpObj.provinceName) {
                        Model.userInfo.province.key = corpObj.provinceName;
                        Model.userInfo.province.value = regionService.getProvinceFromList(corpObj.provinceName, Model.provinces)
                    }

                    if (corpObj.cityName) {
                        regionService.setCity(Model.userInfo.province.key, function (data) {
                            Model.cities = data;
                            Model.userInfo.city = {
                                'key': corpObj.cityName,
                                'value': regionService.getCityFromList(corpObj.cityName, Model.cities)
                            };
                        });
                    }


                    if (devObj.learnchannels) {
                        Model.channelsChecked = devObj.learnchannels.split(';');
                        for (var ch2 = 0; ch2 < Model.channelsChecked.length; ch2++) {
                            Model.channelsChecked[ch2] = parseInt(Model.channelsChecked[ch2]);
                        }
                    }

                    if (devObj.learnchannelsOther) {
                        Model.userInfo.learnchannelsOther = devObj.learnchannelsOther;
                    }


                    if (devObj.remark4userinfo) {
                        Model.userInfo.remark4userinfo = devObj.remark4userinfo;
                    } else {
                        Model.userInfo.remark4userinfo = "";
                    }
                    if (devObj.appealAttach) {
                        Model.userInfo.appealAttach = devObj.appealAttach;
                    }
                    if (corpObj.attachment10) {
                        Model.userInfo.contactorImg10 = corpObj.attachment10;
                    }
                    if (corpObj.attachment4) {
                        Model.userInfo.corpEntityPicFile = corpObj.attachment4;
                    }

                    if (corpObj.attachment5) {
                        Model.userInfo.corpEntityPicFile1 = corpObj.attachment5;
                    }
                    if (corpObj.attachment2) {
                        Model.userInfo.tax = corpObj.attachment2;
                    }
                    if (corpObj.attachment3) {
                        Model.userInfo.corpCode = corpObj.attachment3;
                    }
                    if (corpObj.attachment7) {
                        Model.userInfo.contactorImg1 = corpObj.attachment7;
                    }
                    if (corpObj.attachment8) {
                        Model.userInfo.contactorImg2 = corpObj.attachment8;
                    }
                    if (corpObj.attachment9) {
                        Model.userInfo.contactorImg3 = corpObj.attachment9;
                    }
                    if (corpObj.attachment6) {
                        Model.userInfo.corpNameChange = corpObj.attachment6;
                    }
                    if (corpObj.attachment11) {
                        Model.userInfo.contactorImg11 = corpObj.attachment11;
                    }
                }

                setDrawImage("contactorImg10", "contactorImg10WH");
                setDrawImage("corpLicense", "corpLicenseWH");
                setDrawImage("corpEntityPicFile", "corpEntityPicFileWH");
                setDrawImage("tax", "taxWH");
                setDrawImage("corpCode", "corpCodeWH");
                setDrawImage("corpEntityPicFile1", "corpEntityPicFile1WH");


                setDrawImage("corpNameChange", "corpNameChangeWH");
                setDrawImage("contactorImg11", "contactorImg11WH");
                setDrawImage("contactorImg1", "contactorImg1WH");
                setDrawImage("contactorImg2", "contactorImg2WH");
                setDrawImage("contactorImg3", "contactorImg3WH");
                $scope.corpUserForm && $scope.corpUserForm.realNameEn && $scope.corpUserForm.realNameEn.$setDirty();

                // 选择的语种
                Model.selectedMsgLang = langService.getLangItemByLang(Model.userInfo.msgLang);
                //是否展示needAppealAttach 申诉附件
                getExtAttr('needAppealAttach').then(function (flag) {
                    if (flag == 1) {
                        Model.needAppealAttach = true;
                    }
                });
                commonUtils.picExtend("imges1", "imges2");
            }

            function setDrawImage(type, typewh) {
                AUI.HTMLUtil.drawImage(180, 120, Model.userInfo[type], function (wh) {
                    $scope.$apply(function () {
                        Model[typewh] = wh;
                    });
                });
            }


            // 设置通知消息语种
            Model.changeMsgLang = function (selected) {
                Model.userInfo.msgLang = selected.key;
            };


        }]);
});

